import { render, staticRenderFns } from "./taxi-course-badge.vue?vue&type=template&id=59fdda72&scoped=true"
import script from "./taxi-course-badge.vue?vue&type=script&lang=js"
export * from "./taxi-course-badge.vue?vue&type=script&lang=js"
import style0 from "./taxi-course-badge.vue?vue&type=style&index=0&id=59fdda72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fdda72",
  null
  
)

export default component.exports